import React from "react";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import { Checkbox, Icon } from "../../common/";
import Helper from "../../../helper/Helper";
import ProductRow from "./productRow/ProductRow";
import ProductRowBox from "./productRowBox/ProductRowBox";
import styles from "../../orders/orderTable/OrderTable.scss";

const ProductTable = props => {
  const {
    browser,
    data,
    searchString,
    toggleCheckbox,
    seller,
    selectedItems,
    onQtyChange,
    selectAll,
    allSelected,
    indeterminate,
    dropdown,
    status,
    onUpdateQty,
    sortColumn,
    onOutOfStock
  } = props;

  const property = Helper.validator(data);

  const rows =
    data && !_.isEmpty(data)
      ? data.map((item, index) => {
          return (
            <ProductRow
              item={item}
              property={property}
              searchString={searchString}
              toggleCheckbox={toggleCheckbox}
              seller={seller}
              onQtyChange={onQtyChange}
              onOutOfStock={onOutOfStock}
              selectedItems={selectedItems}
              dropdown={dropdown}
              key={index}
              status={status}
              onUpdateQty={onUpdateQty}
            />
          );
        })
      : "";

  const box =
    data && !_.isEmpty(data)
      ? data.map((item, index) => (
          <ProductRowBox
            item={item}
            property={property}
            searchString={searchString}
            toggleCheckbox={toggleCheckbox}
            seller={seller}
            onOutOfStock={onOutOfStock}
            onQtyChange={onQtyChange}
            selectedItems={selectedItems}
            key={index}
            dropdown={dropdown}
            status={status}
            onUpdateQty={onUpdateQty}
          />
        ))
      : "";

  const dir = props.dir && props.dir === "asc" ? "desc" : "asc";

  return (
    <div className={styles.ctr}>
      {browser && browser.greaterThan.tablet ? (
        <table className={styles.table}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              {toggleCheckbox ? (
                <th>
                  <Checkbox
                    defaultChecked={allSelected}
                    checked={allSelected}
                    onClick={() => selectAll()}
                    indeterminate={indeterminate}
                    name="head"
                  />
                </th>
              ) : (
                ""
              )}
              {property.haveVal("title") ? (
                <th>{I18n.getText("product-table.name")}</th>
              ) : (
                ""
              )}
              {property.haveVal("sku") ? (
                <th>{I18n.getText("product-table.sku")}</th>
              ) : (
                ""
              )}
              {property.haveVal("partner_sku_unique") ? (
                <th>{I18n.getText("offer.p-sku-unique")}</th>
              ) : (
                ""
              )}
              {property.haveQtyVal("qty") ? <th>{I18n.getText("variants.qty")}</th> : ""}
              {dropdown ? (
                <th>{I18n.getText("stock-request.pending-qty")}</th>
              ) : (
                ""
              )}
              {status === 2 ? <th /> : ""}
              {property.haveVal("fulfilment_date") ? (
                <th
                  onClick={() => sortColumn("fulfilment_date", dir)}
                  className={styles.withSort}
                >
                  {I18n.getText("stock-request.fulfilment-promise")}{" "}
                  {props.sort === "fulfilment_date" ? (
                    <Icon
                      className={styles.arrow}
                      name={dir === "asc" ? "caret-down" : "caret-up"}
                    />
                  ) : (
                    <Icon name={"caret-both"} className={styles.arrow} />
                  )}
                </th>
              ) : (
                ""
              )}
              {status === 1 ? <th /> : ""}
              <th />
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      ) : (
        box
      )}
    </div>
  );
};

export default ProductTable;



// WEBPACK FOOTER //
// ./src/components/stockRequest/productTable/ProductTable.js